import { useEffect, useRef } from "react";

/**
 * Renders a PayPal Hosted Button by dynamically loading the PayPal SDK
 * with the merchant's client-id. Hosted button opens PayPal's own checkout,
 * so the button itself handles the payment amount (configured in PayPal).
 */
export default function PayPalHostedButton({ clientId, buttonId, orderReference }) {
  const containerRef = useRef(null);
  const containerId = `paypal-container-${buttonId}`;

  useEffect(() => {
    if (!clientId || !buttonId) return;

    const scriptId = "cka-paypal-sdk";
    let script = document.getElementById(scriptId);

    const render = () => {
      if (window.paypal && window.paypal.HostedButtons && containerRef.current) {
        containerRef.current.replaceChildren();
        window.paypal.HostedButtons({ hostedButtonId: buttonId })
          .render(`#${containerId}`)
          .catch((err) => console.warn("PayPal button render failed:", err));
      }
    };

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&components=hosted-buttons&disable-funding=venmo&currency=AUD`;
      script.async = true;
      script.onload = render;
      document.body.appendChild(script);
    } else if (window.paypal) {
      render();
    } else {
      script.addEventListener("load", render);
    }

    const currentContainer = containerRef.current;
    return () => { if (currentContainer) currentContainer.replaceChildren(); };
  }, [clientId, buttonId, containerId]);

  if (!clientId || !buttonId) {
    return (
      <p className="text-xs text-white/50">
        PayPal configuration missing — please contact Cam directly to complete payment.
      </p>
    );
  }

  return (
    <div className="bg-white p-4">
      {orderReference && (
        <p className="text-black text-xs mb-3 font-mono">
          Reference: <strong>{orderReference}</strong> — include in PayPal notes if possible.
        </p>
      )}
      <div id={containerId} ref={containerRef} data-testid="paypal-button-container" />
    </div>
  );
}
